export default class ThemeFetchError extends Error {
  constructor(message: string) {
    super(message)

    this.name = 'ThemeFetchError'
  }
}
